module.exports = __webpack_public_path__ + "img/land-mine.78b88c90.png";